import(/* webpackMode: "eager" */ "/vercel/path0/src/app/dapps/page.tsx");
